const s = (r, n) => [
  ...new Map(
    r.filter(Boolean).reverse().map((e) => [e[n], e])
  ).values()
].reverse();
export {
  s as getUniqueItemsByKey
};
